import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface ISupervisionDataTableRowFormMeta {
  identifier: FormInputMeta,
  name: FormInputMeta,
  lastUpTime: FormInputMeta,
  lastDownTime: FormInputMeta,
  status: FormInputMeta,
  //
  schema: any,
}

const SupervisionDataTableRowFormMeta = {} as ISupervisionDataTableRowFormMeta;

SupervisionDataTableRowFormMeta.identifier = {
  name: 'identifier',
  type: 'text',
  label: 'ID',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
SupervisionDataTableRowFormMeta.name = {
  name: 'name',
  type: 'text',
  label: 'Nom',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
SupervisionDataTableRowFormMeta.lastUpTime = {
  name: 'lastUpTime',
  type: 'datetime',
  label: 'Dernier UpTime',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
SupervisionDataTableRowFormMeta.lastDownTime = {
  name: 'lastDownTime',
  type: 'datetime',
  label: 'Dernier DownTime',
  placeholder: '',
  validation: yup.string().required("Champ obligatoire !"),
};
SupervisionDataTableRowFormMeta.status = {
  name: 'status',
  type: 'select',
  label: 'Statut',
  options: [
    {
      label: "DOWN",
      value: 'down',
    },
    {
      label: "SIGNON",
      value: 'signon',
    },
    {
      label: "SIGNOFF",
      value: 'signoff',
    },
  ],
  validation: yup.string().required("Champ obligatoire !"),
};

SupervisionDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(SupervisionDataTableRowFormMeta));

export default SupervisionDataTableRowFormMeta;
